<template>
    <Card>
      <AjaxForm v-if="guild" :route="'admin/Guild/Edit/'+guild._id">
        <div class="row">
          <div class="col-12 col-md-6">
            <CustomInput name="title" type="text" v-model="guild.title" placeholder="عنوان..." label="عنوان"></CustomInput>
          </div>
          <div class="col-12 col-md-6">
            <CustomInput v-model="is_open" name="is_open" type="select" label="وضعیت بازار" placeholder="وضعیت را انتخاب کنید"
                         :select-options="is_open_options" reduce_select="value"
                         select-label="title">
            </CustomInput>
          </div>
          <div class="col-12 col-md-6">
            <CustomInput name="date_open" v-model="date" label="تاریخ باز شدن" placeholder="تاریخ را انتخاب کنید" type="date" :date-time="true"></CustomInput>
          </div>
          <div class="col-12 col-md-6 d-flex">
            <label class="mr-3">تصویر بنر</label>
            <ImagePicker :file_id="guild.pic_id" :file_url="guild.pic_url" name="pic_id"></ImagePicker>
          </div>
        </div>
        <div class="row">
          <div class="col-9 col-md-5 mx-auto mt-3">
            <button type="submit" class="btn btn-success btn-block">ویرایش اطلاعات صنف</button>
          </div>
        </div>
      </AjaxForm>
      <div v-if="error" class="alert alert-danger">{{error}}</div>
    </Card>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import Card from "@/components/forms/Card";
import AjaxForm from "@/components/forms/AjaxForm";
import CustomInput from "@/components/CustomInput";
import {AppApi} from "@/api/AppApi";
import {mapActions} from "vuex";
import {findSelectItem} from "@/shared/helper";
import ImagePicker from "@/components/ImagePicker";

export default {
name: "GuildEdit",
  components: {CustomInput, AjaxForm, Card, MasterLayout,ImagePicker},
  data()
  {
    return{
      is_open_options : [{value : '1',title : 'باز'},{value : '0',title : 'بسته'}],
      date : null,
      guild : null,
      error : null,
      id : this.$route.params.id,
      is_open : null,
    }
  },
  mounted()
  {
    this.setPageTitle('ویرایش اطلاعات صنف');
    this.setShowHead(true);
    this.initPage();
  },
  methods: {
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    async initPage()
    {
      this.setPageLoading(true);
      this.error = false;
      this.guild = false;
      this.id = this.$route.params.id;
      const result = await AppApi.getGuildInfoForEdit(this.id);
      if (result.ok)
      {
        this.guild = result.guild;
        this.date = this.guild.date_open;
        if (this.guild.is_open)
        {
          this.is_open = findSelectItem('1',this.is_open_options,'value');
        }
        else
          this.is_open = findSelectItem('0',this.is_open_options,'value');
      }
      else
      {
        this.error = result.error;
      }
      this.setPageLoading(false);
    }
  },watch:{
    is_open:{
      handler()
      {
        console.log(this.is_open)
      }
    }
  }
}
</script>

<style scoped>

</style>